import $ from 'jquery';

class PrimaryNav {

  constructor(){
    this.navigation       = document.querySelector('#js--primary-nav');
    this.navigationToggle = document.querySelector('#js--primary-header-toggle');
    this._init();
  }

  _init(){

    document.addEventListener('DOMContentLoaded', (event) => {

      // this.navigationToggle.on('click', function(){
      //   $(this).toggleClass('js--active');
      //   this.navigation.toggleClass('js--active');
      // });

      this.navigationToggle.addEventListener('click', 
        this._updateNav.bind(this),
        false
      );

    });
  }

  _updateNav(){
    this._toggleState(this.navigation, 'open', 'closed');
    this._toggleState(this.navigationToggle, 'open', 'closed');
  }

  _toggleState(elem, one, two){
    let newState = elem.getAttribute('data-state') === one ? two : one;
    elem.setAttribute('data-state', newState);
  }

}

export let primaryNav = new PrimaryNav();
